<template>
  <div :class="mob ? 'wd-100p' : ''">
    <div class="pos-a zindex-99 right-10 bottom-10 font-12">
      <a href="https://silversea-media.com" class="cr-white text-shadow" target="_blank">Powered by Silversea Media</a></div>

    <textBox :pInfo="pInfo" v-if="pInfo" :show="show" @textBoxShow="textBoxShow"></textBox>
    <div class="pos-a zindex-99 right-0 top-0 pd-10">
      <div class="dp-flex jus-c">
        <div @click="setLang('vn')" class="pointer mg-l-5"><img src="@/assets/lang/vn.png" /></div>
        <div @click="setLang('en')" class="pointer mg-l-5"><img src="@/assets/lang/en.png" /></div>
      </div>
      <div class="pos-r dp-flex jus-e">
        <div @click="textBoxShow(true)" class="wd-40 ht-40 br-rs-6 bg-white-05 dp-flex jus-c pointer">
          <img src="@/assets/icon_i.png" />
        </div>
      </div>
    </div>

    <div class="pos-a zindex-99 ht-100vh cr-white all-an" :class="expand ? mob ? 'wd-60p' : 'wd-300' : 'wd-120'">
      <!-- pc 一级菜单 -->
      <div class="wd-100p bg-2 dp-flex jus-c" :class="expand ? mob ? 'ht-90' : 'ht-170' : 'ht-90'">
        <a href="http://designstudies.vn/" target="blank"><img src="@/assets/logo.png" class="ht-70p" /></a>
      </div>
      <div class="ht-8 bg-lan"></div>
      <div class="ov-a-y bg-white-06 all-an" :class="expand ? mob ? 'ht-100p-138 ' : 'ht-100p-218' : 'ht-0'">
        <div class="pd-20">
          <div class="cr-hei font-18 br-cr-b-hei03 ht-40 dp-flex pointer" :class="j == mid ? 'on' : ''"
            v-for="(n, j) in menu.firstMenu" :key="j" @click="clickref(n, j)" v-if="n.display">
            {{ n.name | showTitle }}
          </div>
        </div>
      </div>
      <div class="ht-40 bg-white-06 pos-r ov-h">
        <div class="pos-a right-0 top-0 pointer" @click="tabExpand">
          <div class="pos-a right-0 bottom-0">
            <Icon v-if="expand" size="20" class="transform-45" type="md-arrow-up" />
            <Icon v-else size="20" class="transform-45" type="md-arrow-down" />
          </div>
          <div class="triangle-bottomright"></div>
        </div>
      </div>

    </div>
    <div class="pos-a right-10 top-20" @click="clickShowMenu" v-if="mob">
      <img v-if="display.menu" class="ht-30" src="@/assets/icon_colse.png" />
      <img v-else class="ht-30" src="@/assets/icon_muen.png" />
    </div>

  </div>
</template>
<style scoped>
.triangle-bottomright {
  width: 0;
  height: 0;
  border-bottom: 40px solid #0083CB;
  border-left: 40px solid transparent;

}
</style>

<script>
import textBox from "@/components/window/textBox.vue";
export default {
  components: {
    textBox
  },
  data() {
    return {
      show: false,
      expand: true,
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    },
    display() {
      return this.$store.state.display;
    },
    mob() {
      return this.$store.state.mob;
    },
    mid() {
      let id = this.$store.state.mid;
      let link = this.menu.firstMenu[id].link;
      this.$store.dispatch("getVirtualLink", link);
      return id;
    },
    menu() {
      return this.$store.state.menuList;
    },
    pInfo() {
      console.log(this.$store.state.pInfo[this.$store.state.lang])
      return this.$store.state.pInfo[this.$store.state.lang];
    },
  },
  created() {
  },
  mounted() {
    this.$store.dispatch("getMob");
  },
  watch: {
  },
  methods: {
    tabExpand() {
      this.expand = !this.expand;
    },
    textBoxShow(val) {
      this.show = val;
    },
    async clickref(ref, index) {
      // this.pushr(ref);
      this.$store.commit("SET_MID", index);
      await this.$store.dispatch("getVirtualLink", ref.link);
    },
    clickShowMenu() {
      this.$store.commit("SET_DISPLAY_SHOW", !this.display.menu);
    },
    async setLang(lang) {
      await this.$store.commit("SET_LANG", lang);
      let link = this.menu.firstMenu[this.mid].link;
      this.$store.dispatch("getVirtualLink", link);
    },
  },
  beforeDestroy() { },
};
</script>